import addOnsData from '../assets/libraries/add-ons.json';
import productPlaceholder from '../assets/images/product-placeholder.svg';

export const STORE_CATEGORIES = [
    { id: 'accessories', label: 'Accessories' },
    { id: 'installation', label: 'Installation Tools' },
    { id: 'goods', label: 'Goods' },
    { id: 'services', label: 'Services' },
    { id: 'rails', label: 'Rails' },
];

const getProductId = (product, category) => {
    if (category === 'rails') {
        return `rails-${product.sku}-${product.dimension}`;
    }
    return `${category}-${product.sku}`;
};

export const getAllProducts = () => {
    const products = [];

    STORE_CATEGORIES.forEach(({ id: category, label: categoryLabel }) => {
        (addOnsData[category] || []).forEach((product) => {
            products.push({
                ...product,
                id: getProductId(product, category),
                category,
                categoryLabel,
                packSize: product['Unnamed: 6'] || null,
            });
        });
    });

    return products;
};

export const getProductsByCategory = () => {
    const grouped = {};

    STORE_CATEGORIES.forEach(({ id, label }) => {
        grouped[id] = {
            id,
            label,
            products: getAllProducts().filter((p) => p.category === id),
        };
    });

    return grouped;
};

export const findProductById = (productId) =>
    getAllProducts().find((p) => p.id === productId) || null;

/** Returns a product image URL, falling back to a placeholder until images are populated. */
export const getProductImage = (product) =>
    product?.image || productPlaceholder;

export const formatPrice = (price) =>
    (price ?? 0).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

export const filterProducts = (products, searchTerm) => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return products;

    return products.filter((product) => {
        const haystack = [
            product.name,
            product.sku,
            product.description,
            product.categoryLabel,
            product.packSize,
        ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();

        return haystack.includes(term);
    });
};
